export * from "./signup-form-footer-text";